const defaultExtensions = new Map([
  [Promise, {
    peek: () => {
      return function (callback) {
        let result, error;
        let status = 'fulfilled';

        return this.then(
          r => {
            result = r;

            return r;
          },
          e => {
            error = e;
            status = 'rejected';
            throw e;
          },
        ).finally(() => callback({status, result, error, succeeded: status === 'fulfilled'}));
      };
    }
  }],
  [Array, {
    peek: () => {
      return function (callback) {
        return this.forEach(callback) && this;
      };
    },
    fold: () => {
      return function (callback, acc = {}) {
        for (let i = 0; i < this.length; i++) {
          callback(acc, this[i], i, this);
        }

        return acc;
      };
    }
  }],
]);

const init = type => {
  const prototype = type.prototype;
  const extensions = (prototype.__extensions ||= {});

  return {extensions, prototype};
}

const extend = (type, propertyName, extender, force = false) => {
  const {extensions, prototype} = init(type);
  const extension = extensions[propertyName];

  if (extension && !force) {
    return false;
  }

  const property = prototype[propertyName];

  const original = {
    extension,
    property,
  };

  prototype[propertyName] = extender(original);

  extensions[propertyName] = {
    original,
    type,
    propertyName,
  };

  return true;
};

for (const [type, properties] of defaultExtensions) {
  for (const [propertyName, extender] of Object.entries(properties)) {
    extend(type, propertyName, extender);
  }
}
